export default [
  [[5, 2], [3, 4]],
  [[1, 5], [2, 3]],
  [[1, 4], [5, 3]],
  [[4, 2], [3, 1]],
  [[4, 5], [2, 1]]
];
